import React from 'react';
import Label from 'components/form/Label/Label';
import { Image } from 'components/Image/Image';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { SUBSCRIPTION_VERTICAL } from 'types/mrph.vertical.constants';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { factorMapping } from 'customHelpersPath/factorMapping.helper';
import classnames from 'classnames';
import { useEventHandler } from 'hook/event.hook';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useConfig } from 'hook/config.hook';
import { getAlaCartePurchaseFlowLink } from 'pages/AlaCartePurchase/alaCartePurchase.helper';
import { OVERVIEW_FACTOR_UPDATE } from 'global_types/ctaUpsell';

const FactorUpdateButton = props => {
  const { is1B, selectedBureau, linkClassName, linkConditionalName } = props;
  const { selectedFactor } = useSelector(state => ({
    selectedFactor: state?.score1b3bFactorDial?.factor?.selectedFactor,
  }));
  const eventHandler = useEventHandler();
  const history = useHistory();
  const { config } = useConfig();
  const { alaCartePurchaseFlowType } = config ?? {};

  const onClick = () => {
    const redirectLink = getAlaCartePurchaseFlowLink(alaCartePurchaseFlowType);
    eventHandler(CLICK, {
      'Click Type': 'Update To Premium View Pop Up',
      'Module Name': 'Grade Dial 3B - ' + factorMapping?.get(selectedFactor),
      Vertical: SUBSCRIPTION_VERTICAL,
    });

    const redirectTo = is1B ? '/plus/upgrade' : redirectLink;
    history.push(redirectTo);
  };

  return (
    <FlexContainer
      className={classnames(
        'router-link bgGray005 border-rad8px justify-center pointer',
        linkClassName,
        linkConditionalName,
      )}
      onClick={onClick}
    >
      <FlexContainer
        className={classnames('items-align-center margLR4', {
          'flex-column': selectedBureau === 'ALL',
          'padtb6 gap-6 justify-center': selectedBureau !== 'ALL',
        })}
      >
        <Image className={'refreshBlue'} />
        <Label type="Lato-Bold" className={'bold margt2 text-8 link'}>
          {OVERVIEW_FACTOR_UPDATE}
        </Label>
      </FlexContainer>
    </FlexContainer>
  );
};

export default FactorUpdateButton;
